import { type ReactNode } from 'react';
import { Pressable, Text, View } from 'react-native';
import { Chip } from '../../components/ui';
import { C } from '../../components/theme';
import { medidasCaixas, useTamCaixas, type TamCaixas } from '../../lib/caixas';
import { Recolhivel, type RecolhivelProps } from '../../components/Recolhivel';

export function Card({ children }: { children: ReactNode }) {
  const m = useTamCaixas();   // segue o "Tamanho das caixas" (texto 07 B3)
  return <View style={{ backgroundColor: C.card, borderRadius: m.raio, padding: m.card, gap: m.cardGap }}>{children}</View>;
}

// Texto 28 (ajuste): o nome da linha nunca quebra no meio da palavra. CAUSA: o nome tinha "flex: 1" (largura zero de
// partida) e o valor longo (ex.: a identificação da atualização) ocupava quase toda a linha; o nome ficava espremido e
// quebrava letra a letra ("Ide-nti-fic-aç-ão"). Agora o nome fica com a largura dele e, se faltar espaço, o valor
// desce para a linha de baixo (alinhado à direita).
export const Linha = ({ l, children }: { l: string; children: ReactNode }) => (
  <View style={{ flexDirection: 'row', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', columnGap: 10, rowGap: 2 }}>
    <Text style={{ color: C.text, flexGrow: 1, flexShrink: 0, maxWidth: '100%' }}>{l}</Text>
    <View style={{ flexShrink: 1, maxWidth: '100%', marginLeft: 'auto', alignItems: 'flex-end' }}>{children}</View>
  </View>
);

export function Contador({ v, on, cor, min = 0 }: { v: number; on: (n: number) => void; cor: string; min?: number }) {
  return (
    <View style={{ flexDirection: 'row', alignItems: 'center', gap: 10 }}>
      <Chip cor={cor} small on={false} label="−" onPress={() => on(Math.max(min, v - 1))} />
      <Text style={{ color: C.text, fontWeight: '800', width: 28, textAlign: 'center' }}>{v}</Text>
      <Chip cor={cor} small on={false} label="+" onPress={() => on(v + 1)} />
    </View>
  );
}

/** Botão grande do menu de Ajustes: ícone, título, resumo e seta. Segue o "Tamanho das caixas" (texto 07 B3). */
export function BotaoMenu({ icon, titulo, resumo, onPress, cor, direita, semSeta, tam }: { icon: string; titulo: string; resumo?: string; onPress: () => void; cor?: string; direita?: ReactNode; semSeta?: boolean; tam?: TamCaixas }) {
  const atual = useTamCaixas();
  const m = tam ? medidasCaixas(tam) : atual;   // tam: prévia de outro tamanho (Aparência > Tamanho das caixas)
  return (
    <Pressable onPress={onPress} style={({ pressed }) => ({ flexDirection: 'row', alignItems: 'center', gap: m.gap, paddingVertical: m.pad, paddingHorizontal: m.padH, borderRadius: m.raio,
      backgroundColor: pressed ? C.card2 : C.card })}>
      <Text style={{ fontSize: m.icone, width: m.icone + 8, textAlign: 'center' }}>{icon}</Text>
      <View style={{ flex: 1, gap: 2 }}>
        <Text style={{ color: cor ?? C.text, fontSize: m.titulo, fontWeight: '700' }}>{titulo}</Text>
        {!!resumo && m.resumo && <Text style={{ color: C.sub, fontSize: 12 }} numberOfLines={m.tam === 'g' ? 2 : 1}>{resumo}</Text>}
      </View>
      {direita}
      {!semSeta && <Text style={{ color: C.mute, fontSize: m.tam === 'p' ? 18 : 22 }}>›</Text>}
    </Pressable>
  );
}

/** Seção que abre e fecha ao tocar no título: é o componente ÚNICO do app (components/Recolhivel.tsx), no visual "linha".
 *  chave: guarda neste aparelho o que a pessoa deixou aberto ou fechado. forcarAberto: mostra aberta sem mudar o guardado. */
export function Expansivel(p: Omit<RecolhivelProps, 'visual'>) {
  return <Recolhivel {...p} visual="linha" />;
}
